export default __webpack_public_path__ + "static/media/ico_home.97c349e4.svg";